import * as React from 'react';
import { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { IdentityService } from '../../services/IdentityService';
import { LoaderComponent } from '../../controls/Loader';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { IResetPassword } from '../../models/IResetPassword';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';
import { connect } from 'react-redux';
import { IUserInfo } from '../../models/IUserInfo';
import Footer from './Footer';
import { ImageContainer } from './ImageContainer';
import { FormGroup } from '../../controls/Form/FormGroup';
import { PasswordHelpBlock } from './PasswordHelpBlock';
import {
    GetPasswordValidationState,
    GetConfirmPassowrdValidationState,
    fullPasswordChangeValidation
} from './PasswordValidation';

function MapState(state) {
    return {
        UserInfo: state.Profile
    }
}

interface IProps extends RouteComponentProps<any> {
    UserInfo: IUserInfo | null;
}

interface IState {
    UserId?: string;
    ResetCode?: string;
    IsFormPristine: boolean;
    LoaderVisible: boolean;
    Password?: string;
    ConfirmPassword?: string;
    ResetSuccess: boolean;
}

class ResetPasswordComponent extends Component<IProps, IState> {
    private didSubmit = false;

    constructor(props) {
        super(props);

        let userId = this.props.match.params.id;
        let resetCode = this.props.match.params.code;

        this.state = {
            UserId: userId,
            ResetCode: resetCode,
            IsFormPristine: true,
            LoaderVisible: false,
            ResetSuccess: false
        }
    }

    public render() {
        const { LoaderVisible, IsFormPristine, ResetSuccess, Password, ConfirmPassword } = this.state;
        return (
            <div className="login-component route-component form-component">
                <div className="content-container">
                    <div className="content">
                        <LoaderComponent Visible={LoaderVisible} />
                        <div className="form-container">
                            <div className="form-container__wrapper">
                                <div className="kif-logo" />
                                <div className="header">
                                    {ResetSuccess ?
                                        <>
                                            <h3>Hasło zmienione</h3>
                                            <span className="sub-header">Hasło zostało pomyślnie zmienione.</span>
                                        </>
                                        :
                                        <h3>Ustaw nowe hasło</h3>
                                    }
                                </div>
                                {
                                    ResetSuccess ?
                                        <div className="submit-success-container">
                                            <div className="password-reset-success" />
                                            <div className="form-buttons">
                                                <input type="submit" className="confirm-button-orange" value="Zaloguj się do serwisu" onClick={this.RedirectToLogin} />
                                            </div>
                                        </div> :
                                        (<form onSubmit={this.OnFormSubmit} className={IsFormPristine ? 'pristine' : ''}>
                                            <FormGroup
                                                Name="Password"
                                                OnChange={this.OnInputChange}
                                                Label="Nowe hasło"
                                                Value={Password}
                                                Type="password"
                                                ClassName="form-group--no-margin"
                                                ValidationState={this.GetPasswordValidationStateHandler}
                                                ErrorBlock="Hasło musi zawierać conajmniej 8 znaków"
                                            />
                                            <PasswordHelpBlock Password={Password} />
                                            <FormGroup
                                                Name="ConfirmPassword"
                                                OnChange={this.OnInputChange}
                                                Label="Potwierdź hasło"
                                                Value={ConfirmPassword}
                                                Type="password"
                                                ClassName="form-group--no-margin"
                                                ValidationState={this.GetConfirmPassowrdValidationStateHandler}
                                                ErrorBlock="Wpisane hasło jest nieprawidłowe"
                                            />

                                            <div className="form-buttons">
                                                <input type="submit" className="confirm-button-orange" value="Zmień hasło" />
                                            </div>
                                        </form>)
                                }
                            </div>
                        </div>
                        <ImageContainer />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }//end-of-render

    private GetPasswordValidationStateHandler = (): 'success' | 'warning' | 'error' | undefined => {
        return GetPasswordValidationState(this.didSubmit, this.state.Password);
    }

    private GetConfirmPassowrdValidationStateHandler = (): 'success' | 'warning' | 'error' | undefined => {
        return GetConfirmPassowrdValidationState(this.didSubmit, this.state.Password, this.state.ConfirmPassword);
    }

    private OnInputChange = (event) => {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState({
            ...partialState,
            IsFormPristine: false
        });
    }

    private OnFormSubmit = (event): void => {
        this.didSubmit = true;
        const { Password, ConfirmPassword, ResetCode, UserId } = this.state;
        if (fullPasswordChangeValidation(Password, ConfirmPassword, this.didSubmit)) {
            if (UserId !== undefined &&
                ResetCode !== undefined &&
                Password !== undefined &&
                ConfirmPassword !== undefined
            ) {
                let service = new IdentityService();
                let data: IResetPassword = {
                    Id: UserId,
                    Password,
                    ConfirmPassword,
                    Code: ResetCode
                }
                service.ResetPassword(data, this.OnResetSuccess, this.OnResetError);
                this.setState({
                    LoaderVisible: true
                });
            }
        } else {
            ShowStatusBar('Info', 'Proszę sprawdzić poprawność formularza', DEFAULT_STATUS_TIMEOUT);
            this.setState({}); //Triggers validation feedback info
        }
        event.preventDefault();
    }

    private OnResetSuccess = (result) => {
        this.setState({
            LoaderVisible: false,
            ResetSuccess: true
        });
    }

    private OnResetError = (error) => {
        ShowStatusBar('Error', 'Nie udało się zresetować hasła. Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
        this.setState({
            LoaderVisible: false
        });
    }

    private RedirectToLogin = (evt) => {
        this.props.history.push('/');
    }
}

export default connect(MapState)(ResetPasswordComponent);


// WEBPACK FOOTER //
// ./src/components/Login/ResetPassword.tsx